import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams} from '@angular/common/http';
import { Usuarioweb } from '../models/Usuarioweb';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Params } from '../../params';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public uri_api: string;
  public formData: FormData;

  constructor(private http: HttpClient,private storageService: StorageService, private ruta: Router) {
    this.uri_api=Params.url_api;
   }

  verifyAccess():boolean{
    if(this.storageService.getJsonValueSession("user")!==null){
      return this.storageService.getJsonValueSession("user")['login'];
    }else{
      return false;
    }
  }

  auth(usr: Usuarioweb): Observable<any> {
    let params = new HttpParams();
    this.formData = new FormData();
    this.formData.append('username', usr.matricula);
    this.formData.append('password', usr.pwd);
    this.formData.append('grant_type', 'password');
    let username='frontendapp'
    let password='12345'
    const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(username + ':' + password) });
    return this.http.post(this.uri_api + '/security/oauth/token', this.formData, { headers: headers });
  }

  logout(): void{
    this.storageService.removeSession('user');
    this.ruta.navigate(['/login']); 
  }

  //******** SERVICIOS COSSMIL ********/
  verifyAsegurado(mtr: String): Observable<any> {
    return this.http.get(this.uri_api + '/safil/verify/'+mtr);
  }
  verifyUsuarioweb(mtr: String): Observable<any> {
    return this.http.get(this.uri_api+ '/usuarioweb/verify/'+mtr);
  }
  verifyAseguradoMtrCi(mtr: String,ci: String): Observable<any> {
    return this.http.get(this.uri_api + '/safil/verify/'+mtr+'/'+ci);
  }
  buscarPorMatriculaCi(mtr: string,ci: string): Observable<any> {
    let headers=new HttpHeaders().set(Params.authorization,Params.bearer+this.storageService.getJsonValueSession("user")['access_token']);
    return this.http.get(this.uri_api + '/safil/asegurado/'+mtr+'/'+ci,{headers:headers});
  }
  //************ NUEVOS SERVICIOS DE ACCESO ************* */
  verificaAcceso(mtr: String): Observable<any> {
    return this.http.get(this.uri_api + '/citas/verifica-acceso/'+mtr);
  }
  verificaUsuario(mtr: String, ci: String, tipo:Number): Observable<any> {
    return this.http.get(this.uri_api + '/citas/verifica-usuario/'+mtr+'/'+ci+'/'+tipo);
  }
}

